export default {"src":"/org/_next/static/media/my-videos.0e3ecdb9.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};